import { createContext, useContext, useMemo, useState } from 'react';
import { useAuth } from '../../Contexts/AuthProvider';

const UserProfileContext = createContext();

export const useProfileInfo = () => useContext(UserProfileContext);

function UserProfileProvider({ children }) {
    const [propertyName, setPropertyName] = useState(false);

    const { authInfo } = useAuth();

    const [formData, setFormData] = useState({ ...authInfo?.data });

    const value = useMemo(() => {
        // --Handle edit click
        const handleEditClick = (name, val) => {
            setPropertyName(name);
            setFormData({ [name]: val });
        };

        // --Handler to reset the form data
        const handleReset = () => {
            setFormData({ ...authInfo?.data });
            setPropertyName('');
        };

        // --handler to set input value to state
        const handleChange = (e) => {
            const { name, value: val } = e.target;
            setFormData({
                [name]: val
            });
        };

        return {
            // --input property name
            propertyName,
            setFormData,
            formData,
            handleChange,
            handleEditClick,
            handleReset
        };
    }, [authInfo.data, formData, propertyName]);

    return <UserProfileContext.Provider value={value}>{children}</UserProfileContext.Provider>;
}

export default UserProfileProvider;
